import { BaseModel } from "@puntaje/shared/core"

export class GeneradorInstrumentoDiagnosticoEvaluacion extends BaseModel {
    evaluacion_id: number
    generador_instrumento_id: number
}